module.exports = __webpack_public_path__ + "static/media/setting.f212db03.svg";